import React, { Component, PropTypes } from 'react'

/* Utilities */
import _ from 'lodash'


/* Styles */
import './index.css'

export const SCHEME = {
    REMOVE: 0,
    ACTION: 1
}

/* Single Playlist List Item */
export class RemoveDialog extends Component {

    getClassName() {
        const {
            className,
            scheme
        } = this.props
        let classNameArr = className ?className.split(' '):[]
        classNameArr.push('remove-dialog', 'widget')
        switch (scheme) {
          case SCHEME.ACTION:
            classNameArr.push('action-scheme')
            break;
          case SCHEME.REMOVE:
          default:
            classNameArr.push('remove-scheme')

        }
        return  classNameArr.join(' ')
    }

    getWrapperStyle() {
        const {
            height
        } = this.props
        if (height) return { height: height+"px" }
        else return { height: "100%" }
    }

    render() {
        const {
            uid,
            text,
            onConfirm,
            confirmLabel,
            onCancel,
            cancelLabel,
            height
        } = this.props
        return (
            <div className={ this.getClassName() }
                onMouseDown={ (e) => {e.stopPropagation()} }
                onClick={ (e) => {e.stopPropagation()}  }
            >
                <div className="content-wrapper" style={ this.getWrapperStyle() }>
                    <div className="text"> { text } </div>
                    <div className="spacer"> </div>
                    <div className="buttons">
                        <button
                            onClick={ onConfirm }
                        >
                            { confirmLabel }
                        </button>
                        <button
                            onClick={ onCancel }
                        >
                            { cancelLabel }
                        </button>
                     </div>
                </div>
                <div className="spacer"> </div>
            </div>
        )
    }
}

RemoveDialog.propTypes = {
    text: PropTypes.string,
    scheme: PropTypes.number,
    height: PropTypes.number,
    onConfirm: PropTypes.func,
    confirmLabel: PropTypes.string,
    onCancel: PropTypes.func,
    cancelLabel: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/app/widget/remove-dialog/index.jsx